
import { Injectable } from '@angular/core';

@Injectable()
export class AtivoModel {
    ativoId: number;
    numeroSerie: string;
    numeroPatrimonio: string;
    modelo: string;
    descricaoTipoEquipamento: string;
    fabricante: string;
    ambiente: string;
    enderecos: Array<any>;

    constructor() {
    }
}

export class AtivoResult {
    public sucesso: boolean;
    public erros: Array<any>;
    public warnings: Array<any>;
    public ativo: AtivoModel;
}

